export const StatusFetch = Object.freeze(
  {
    Idle: 'IDLE',
    Success: 'SUCCESS',
    Pending: 'PENDING',
    Error: 'ERROR',
  },
);
